import { Route } from '@angular/router';
import { RouteLanguageResolver } from '@hazmatsuite-next/ui';
import { AddressListComponent } from './components/address-list/address-list.component';

export const addressListRoutes: Route[] = [
  {
    path: '',
    component: AddressListComponent,
    resolve: { lang: RouteLanguageResolver },
    data: {
      resources: ['AddressEditorResource', 'AccountResource', 'AddressListResource', 'ValidationResource', 'GeneralInformationResource'],
    },
  },
  {
    path: ':type',
    component: AddressListComponent,
    resolve: { lang: RouteLanguageResolver },
    data: {
      resources: ['AddressEditorResource', 'AccountResource', 'AddressListResource', 'ValidationResource', 'GeneralInformationResource'],
    },
  },
];
